module.exports = __webpack_public_path__ + "img/daytime_study1_sm.d2dbf84d.png";